module.exports = __webpack_public_path__ + "static/media/XBOX.9879e146.svg";